import React from 'react';
import { useTranslation } from 'react-i18next';

import extractCompanyName from '../../../utils/extractCompanyName';
import SocialCardValueCell from './SocialCardValueCell.jsx';
import { SOCIAL_MEDIA_PARAMETER_TO_LOCALS, SOCIAL_TYPE_COLUMNS } from './constants';
import Icon from '../../../icons/Icon.jsx';

import scss from './BrandSocials.module.scss';

function SocialCard({ data }) {
  const { t } = useTranslation('sonar');
  const { url, logo, socialItemData, type } = data;

  return (
    <div className={scss.cardWrapper}>
      <div className={scss.cardTitleWrapper}>
        <Icon icon={logo} className={scss.cardIcon} disableCommonStyles />
        <a href={url} target='_blank' className={scss.cardLink} rel='noopener noreferrer'>
          {extractCompanyName(url)}
        </a>
      </div>

      <div className={scss.cardValues}>
        {SOCIAL_TYPE_COLUMNS[type]
          .filter((key) => socialItemData[key])
          .map((key) => (
            <SocialCardValueCell
              key={key}
              data={{
                score: socialItemData[key].comparable || 0,
                trend: socialItemData[key].trend || 0,
                prevScore: socialItemData[key].compareTo || 0,
              }}
              header={t(SOCIAL_MEDIA_PARAMETER_TO_LOCALS[key])}
            />
          ))}
      </div>
    </div>
  );
}

export default SocialCard;
